import { render } from "./CostDetail.vue?vue&type=template&id=05585ee8&scoped=true&ts=true"
import script from "./CostDetail.vue?vue&type=script&lang=ts"
export * from "./CostDetail.vue?vue&type=script&lang=ts"

import "./CostDetail.vue?vue&type=style&index=0&id=05585ee8&lang=less&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05585ee8"]])

export default __exports__